import { authenticatedRequest } from "../api";
import { getConfig } from "../config";
import { urlParser } from "../urlParser";

import type { APIObject } from "./Ressource";
import { Ressource } from "./Ressource";

const _url = "/organizations/:organizationId/setup/registry";
const paramDefaults = {};

export class SetupRegistry extends Ressource {
  description: string;
  repo_name: string;
  disk: null;
  docs: Record<string, unknown>;
  endpoint: string;
  min_disk_size: null;
  name: string;
  runtime: null;
  type: string;
  versions: Record<string, unknown>;

  constructor(registry: APIObject, url = _url, modifiableField = []) {
    super(url, paramDefaults, {}, registry, [], modifiableField);
    this._queryUrl = Ressource.getQueryUrl(url);
    this.description = registry.description;
    this.repo_name = registry.repo_name;
    this.disk = registry.disk ?? null;
    this.docs = registry.docs ?? {};
    this.endpoint = registry.endpoint;
    this.min_disk_size = registry.min_disk_size ?? null;
    this.name = registry.name;
    this.runtime = registry.runtime ?? null;
    this.type = registry.type;
    this.versions = registry.versions ?? {};
  }

  static async get(organizationId: string, customUrl?: string) {
    const { api_url } = getConfig();
    const url = customUrl ?? `${api_url}${_url}`;
    const parsedUrl = urlParser(url, { organizationId });

    return authenticatedRequest(parsedUrl, "GET").then(
      (data: Record<string, APIObject>) =>
        typeof data === "undefined"
          ? undefined
          : Object.entries(data).reduce<Record<string, any>>(
              (items, [key, value]) => {
                items[key] = new SetupRegistry(value);
                return items;
              },
              {}
            )
    );
  }
}
